import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import passwordValidator from 'password-validator';
import {Actions as CREATEACCOUNTACTIONS} from '../../store/actions/createAccountActions';
import {Actions as LOGINACTIONS} from '../../store/actions/authenticationActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';


// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
.is().min(8)                                    // Minimum length 8
.is().max(100)                                  // Maximum length 100
.has().uppercase()                              // Must have uppercase letters
.has().lowercase()                              // Must have lowercase letters
.has().digits(1)                                // Must have at least 1 digits
.has().not().spaces()                           // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values


function PayrollGuideRequestRecieved({
  saving,
  saved,
  profile,
  updateLead,
  error,
  logout,
  processing
}) {

  const [data, setData] = useState({
    noOfEmployees: "1-5",
    name: "",
    surname: "",
    phone: "",
    organisation: "",
    email: "",
    street: "",
    city: "",
    postcode: "",
  });

  useEffect(() => {
    // load initial data required for anywhere
    if (profile){
      setData({
        ...data,
        name: profile.givenName || profile.name,
        surname: profile.familyName || profile.surname,
        email: profile.email,
      })
    }
  },[profile]);


  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    })
  }

  const submitForm = (e) => {
    e.preventDefault();
    console.log('dataToSubmit',data)
    updateLead({...data})
  }

  if (profile.street){
    return (
      
      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">


          <h2 className="text-2xl leading-6 font-extrabold tracking-tight text-gray-800 mb-2">
            Hi {profile && profile.givenName || profile.name}, <br/> <span className="text-lg font-extrabold">your payroll guide is on the way</span>
          </h2>

          {/*
          { profile.isHR > 0 && 
              <div>
                <span className="block w-full rounded-md shadow-sm">
                  <a href="https://app.buddy.hr" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Go to Payroll Portal
                  </a>
                </span>
              </div>
          }

          { profile.isEmployee > 0 && 
              <div className="mt-6">
                <span className="block w-full rounded-md shadow-sm">
                  <a href="https://employee.buddy.hr" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Go to Employee Portal
                  </a>
                </span>
              </div>
          }

          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm leading-5 text-center" style={{width: "100%"}}>
              Not {profile.givenName || profile.name}? 
              <a 
                onClick={(e) => {
                  e.preventDefault();
                    e.stopPropagation();
                    logout()
                }} href="#" 
                className="ml-1 pl-2 font-medium text-orange-600 hover:text-orange-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                Log out

                {
                  processing &&
                  <span className="ml-4">
                    <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                      </span>
                }
              </a>
            </div>
          </div>*/}


          
          { profile.isHR == 0 || true && 

            <div className="mt-6">

              <div className="inset-0 flex items-center mb-6">
                <div className="w-full border-t border-gray-200"></div>
              </div>


              <h2 className="text-2xl leading-6 font-extrabold tracking-tight text-gray-800 mb-2">
                Did you explore our Payroll Software?
              </h2>
              <div className="prose prose-orange prose-sm text-gray-800 text=sm mx-auto">
                <p>Here are somet of the things you can do!</p>
                <ul>
                  <li>Single Page Payroll</li>
                  <li>Instant Calculations & Payslip Previews</li>
                  <li>Timesheets to payroll in seconds.</li>
                  <li>Generation of FS3, FS5, FS7 + FSS files</li>
                  <li>Leave & Vacation Management</li>
                  <li>Employee Portal with access to Payslips & Leave</li>
                  <li>Remote Work planning schedule</li>
                  <li>Malta's easiest to understand Payslip</li>
                  <li>+ Chat & Email Support Included</li>
                </ul>
              </div>

              <Link to="/" className="mt-4 w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                Discover Payroll with Buddy
              </Link>
            </div>
          }

        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
        </div>
      </div>
    )
  }

  return (

    <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
      <div className="px-4 py-8 sm:px-10">

        <div className="mt-6">

          <h2 className="text-2xl leading-6 font-extrabold tracking-tight text-gray-800 mb-2">
            Hi {profile && profile.givenName || profile.name}, <br/> <span className="text-lg font-extrabold">we've booked your copy</span>
          </h2>

          <p className="text-gray-800 text-sm mb-4">Let us know where we shall send it</p>

          <form onSubmit={submitForm} className="space-y-6">
            

            <div>
              <label htmlFor="phone" className="sr-only">
                Phone
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['phone']} onChange={handleChange} name="phone" id="phone" placeholder="Phone" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="street" className="sr-only">
                Street
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['street']} onChange={handleChange} name="street" id="street" placeholder="Street" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>


            <div className="grid grid-cols-12  gap-2 sm:gap-8">
              <div className="col-span-6">
                <label htmlFor="city" className="sr-only">
                  City
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.city} onChange={handleChange} name="city" id="city" placeholder="City" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>

              <div className="col-span-6">
                <label htmlFor="postcode" className="sr-only">
                  Postcode
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data.postcode} onChange={handleChange} name="postcode" id="postcode" placeholder="Postcode" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>
            </div>


            
            <div>
              <span className="block w-full rounded-md shadow-sm text-center">

                {
                  saving &&
                    <svg className="text-orange-600 inline-block animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                }
                {!saving && 
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Update my Address
                  </button>
                }
              </span>
            </div>
          </form>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <p className="text-xs leading-5 text-gray-500">We are processing your request for a Payroll Guide. Our team will reach out if we are unable to deliver the payroll guide to your doorstep.</p>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const createAccount = state && state.createAccount

  const userProfile = state && state.my && state.my.profile

  const userData = localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

  const profile = {...userData,...userProfile}

  return {
    saving: createAccount.savingLead,
    saved: createAccount.savedLead,
    profile: profile,
    processing: state.authentication.processing,
  }
}

const mapDispatchToProps = dispatch => ({
  updateLead: (data) => dispatch(CREATEACCOUNTACTIONS.updateLead(data)),
  logout: () => dispatch(LOGINACTIONS.logout()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayrollGuideRequestRecieved) 
